import { render, staticRenderFns } from "./DriverAppContainerDetail.vue?vue&type=template&id=aece1104&scoped=true"
import script from "./DriverAppContainerDetail.vue?vue&type=script&lang=js"
export * from "./DriverAppContainerDetail.vue?vue&type=script&lang=js"
import style0 from "./DriverAppContainerDetail.vue?vue&type=style&index=0&id=aece1104&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aece1104",
  null
  
)

export default component.exports